/**
 * don't hide the dropdown when user mouse down and move outside, #392
 * the order of events is mousedown -> mouseup -> click
 */
import { onBeforeUnmount, onMounted } from 'intact-react';
import { containsOrEqual } from './useDocumentClick';
export function useMouseOutsidable(elementRef, autoAdd) {
  if (autoAdd === void 0) {
    autoAdd = true;
  }
  var timer = null;
  function onMouseDown() {
    document.addEventListener('click', onDocumentClick, true);
    document.addEventListener('mouseup', onMouseUp);
  }
  function onMouseUp() {
    timer = window.setTimeout(function () {
      document.removeEventListener('click', onDocumentClick, true);
      timer = null;
    });
    document.removeEventListener('mouseup', onMouseUp);
  }
  function onDocumentClick(e) {
    if (!containsOrEqual(elementRef.value, e.target)) {
      e.stopPropagation();
    }
  }
  if (autoAdd) {
    onMounted(function () {
      elementRef.value.addEventListener('mousedown', onMouseDown);
    });
  }
  onBeforeUnmount(function () {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    if (autoAdd) {
      elementRef.value.removeEventListener('mousedown', onMouseDown);
    }
    document.removeEventListener('click', onDocumentClick, true);
    document.removeEventListener('mouseup', onMouseUp);
  });
  return {
    onMouseDown: onMouseDown
  };
}